/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export var TagValueType = {
    Alphanumeric: 'ALPHANUMERIC',
    Numeric: 'NUMERIC',
    Boolean: 'BOOLEAN',
    Date: 'DATE',
    DateTime: 'DATE_TIME',
    NoValue: 'NO_VALUE'
};
export function TagValueTypeFromJSON(json) {
    return TagValueTypeFromJSONTyped(json, false);
}
export function TagValueTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function TagValueTypeToJSON(value) {
    return value;
}
